import type { TicMeta } from 'types/tic';

export interface TagListOption {
  value: number;
  name: string;
  hasChildren: boolean;
}

export interface TagBase {
  id: number;
  name: string;
  emoji?: string | undefined;
  parent?: TagBase | null;
}

export interface Tag extends TagBase {
  active?: boolean;
  budget?: number | null;
  parent_id?: number | null;
  children?: Array<Tag>;
  sequence: number;
  hasBeenRemoved?: boolean;

  /**
   * TIC (Timely Integration Cloud) metadata.
   * Only present for tags synced from TIC.
   * @see TicMeta
   */
  tic?: TicMeta;
}

export enum TagFilterMode {
  AND = 'AND',
  OR = 'OR',
}
